/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { mapValues } from '../runtime';
import { FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigTosUrlOpenMethodFromJSON, FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigTosUrlOpenMethodToJSON, } from './FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigTosUrlOpenMethod';
import { FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigPpUrlOpenMethodFromJSON, FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigPpUrlOpenMethodToJSON, } from './FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigPpUrlOpenMethod';
import { FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactsValueFromJSON, FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactsValueToJSON, } from './FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactsValue';
/**
 * Check if a given object implements the FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfig interface.
 */
export function instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfig(value) {
    if (!('IframeType' in value) || value['IframeType'] === undefined)
        return false;
    if (!('TosUrlOpenMethod' in value) || value['TosUrlOpenMethod'] === undefined)
        return false;
    if (!('PpUrlOpenMethod' in value) || value['PpUrlOpenMethod'] === undefined)
        return false;
    if (!('DisableHeaderUi' in value) || value['DisableHeaderUi'] === undefined)
        return false;
    return true;
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'IframeType': json['IframeType'],
        'ExternalTosUrl': json['ExternalTosUrl'] == null ? undefined : json['ExternalTosUrl'],
        'TosUrlOpenMethod': FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigTosUrlOpenMethodFromJSON(json['TosUrlOpenMethod']),
        'ExternalPpUrl': json['ExternalPpUrl'] == null ? undefined : json['ExternalPpUrl'],
        'PpUrlOpenMethod': FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigPpUrlOpenMethodFromJSON(json['PpUrlOpenMethod']),
        'ContactsUrl': json['ContactsUrl'] == null ? undefined : json['ContactsUrl'],
        'HeaderLogo': json['HeaderLogo'] == null ? undefined : json['HeaderLogo'],
        'DisableHeaderUi': json['DisableHeaderUi'],
        'LegalContacts': json['LegalContacts'] == null ? undefined : (mapValues(json['LegalContacts'], FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactsValueFromJSON)),
        'NeedToAcceptRequiredDocuments': json['NeedToAcceptRequiredDocuments'] == null ? undefined : json['NeedToAcceptRequiredDocuments'],
    };
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'IframeType': value['IframeType'],
        'ExternalTosUrl': value['ExternalTosUrl'],
        'TosUrlOpenMethod': FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigTosUrlOpenMethodToJSON(value['TosUrlOpenMethod']),
        'ExternalPpUrl': value['ExternalPpUrl'],
        'PpUrlOpenMethod': FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigPpUrlOpenMethodToJSON(value['PpUrlOpenMethod']),
        'ContactsUrl': value['ContactsUrl'],
        'HeaderLogo': value['HeaderLogo'],
        'DisableHeaderUi': value['DisableHeaderUi'],
        'LegalContacts': value['LegalContacts'] == null ? undefined : (mapValues(value['LegalContacts'], FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactsValueToJSON)),
        'NeedToAcceptRequiredDocuments': value['NeedToAcceptRequiredDocuments'],
    };
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfig.js.map